import { useEffect, useRef } from 'react'
import { cleanCode } from './codes'

/**
 * VH-285 — the one field a code is typed into: at the login, at the set-up
 * and in the dialog before a sensitive action (FinanceHub FH-104).
 *
 * No `maxLength`: a browser cuts a paste to that length BEFORE the page sees
 * it, so "123 456" would arrive as "123 45". The digits are counted here.
 * With `recovery` it takes a recovery code: letters and digits, free text.
 */
export default function CodeField({
  id,
  label,
  hint,
  value,
  onChange,
  recovery = false,
  disabled = false,
  invalid = false,
  describedBy,
  focusKey,
}) {
  const ref = useRef(null)
  useEffect(() => {
    ref.current?.focus()
  }, [focusKey, recovery])

  const hintId = hint ? `${id}-hint` : undefined
  const described = [hintId, describedBy].filter(Boolean).join(' ') || undefined

  return (
    <div>
      <label htmlFor={id} className="form-label">
        {label}
      </label>
      <input
        ref={ref}
        id={id}
        name={recovery ? 'recovery-code' : 'code'}
        type="text"
        inputMode={recovery ? 'text' : 'numeric'}
        pattern={recovery ? undefined : '[0-9]*'}
        autoComplete={recovery ? 'off' : 'one-time-code'}
        autoCapitalize={recovery ? 'characters' : 'off'}
        autoCorrect="off"
        spellCheck={false}
        value={value}
        disabled={disabled}
        aria-invalid={invalid || undefined}
        aria-describedby={described}
        onChange={(event) => onChange(recovery ? event.target.value : cleanCode(event.target.value))}
        className={`form-input font-mono text-lg ${recovery ? 'tracking-wider' : 'tracking-[0.4em]'}`}
      />
      {hint && (
        <p id={hintId} className="mt-1 text-xs text-gray-500">
          {hint}
        </p>
      )}
    </div>
  )
}
